import { Box, Grid, Stack, useMediaQuery } from "@mui/material";
import React, { useRef } from "react";
import { useTheme } from "@emotion/react";
import { useSelector } from "react-redux";
import Form from "../../components/pages/register/personal-interests/Form";
const PersonalInterests = () => {
    const formRef = useRef(null);

    const theme = useTheme();
    const isMdScreen = useMediaQuery(theme.breakpoints.down("md"));
    return (
        <Box className="page">
            <Grid container justifyContent={"center"}>
                <Grid
                    container
                    item
                    direction={"row"}
                    rowSpacing={5}
                    columnSpacing={isMdScreen ? 0 : 10}
                    md={9}
                    sm={12}
                    xs={12}
                >
                    <Grid item xs={12} ref={formRef}>
                        <Form />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default PersonalInterests;
